<template>
  <div
    class="content"
  >
    <h1
      :style="{ fontSize: fontSize + 'px' }"
    >
      {{ msg }}
    </h1>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fontSize: 0,
      msg: null

    }
  },
  created () {
    this.handleResize()
    const message = JSON.parse(localStorage.getItem('msgHide'))
    this.msg = message[0].valor
    document.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    document.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      /** Ratio tamaño de fuente deseada  */
      const ratio = 36 / 1920
      // Calculate equipment width
      const width = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      )
      this.fontSize = width * ratio
    }
  }
}
</script>

<style scoped>
  .content {
      position: fixed !important;
      top: 0px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh !important;
      width: 100% !important;
      z-index: 10000 !important;
      background: rgba(0, 0, 0, .7) !important;
      color: rgba(255, 255, 255, 1)!important;
      text-align: center;
  }
  div.content h1 {
    font-size: 1rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Hide.vue